
/* Rohini 10/29/2022 3075154998 add classname globally for the textfields and buttons
Rohini 10/30/2022 3075154998 add classname globally for the buttons
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function RecordFormatFieldSearchTable({
  searchData,
  setSelectedRows,
  selectedRows,
  fieldType,
  submit,
  setSubmit,
}) {
  const columns = [
    {
      title: 'Filter Code',
      field: 'name',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  useEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData, fieldType]);

  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/filter`;
                const bodyObj = {
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  name: searchData?.code ? searchData.code : '',
                  page: submit ? 1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };

                httpPaginationPost(url, bodyObj).then((response) => {
                  if (response?.status === 200) {
                    const newObj = {};
                    selectedRows.forEach((el) => {
                      if (!newObj[el.id]) {
                        newObj[el.id] = el;
                      }
                    });
                    const newRow = response.data.response.resultObject.map((elem) => {
                      if (newObj[elem.id]) {
                        return {...elem, tableData: {...elem.tableData, checked: true}};
                      } else {
                        return {...elem, tableData: {...elem.tableData, checked: false}};
                      }
                    });

                    resolve({
                      data: newRow.length > 0 ? newRow : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setSubmit(false);
                    setArrayLast(response.data.response.resultObject.length === 1);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            options={{
              search: false,
              selection: true,
              pageSize: rows,
              toolbar: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onSelectionChange={(rows, unSelected) => {
              if (unSelected?.tableData?.checked) {
                setSelectedRows([
                  ...selectedRows,
                  {
                    ...unSelected,
                  },
                ]);
              } else {
                const updatedRows = [...selectedRows]
                  .filter((ele) => ele.id !== unSelected.id)
                  .map((ele) => {
                    return {...ele, tableData: {...ele.tableData, id: ele.id}};
                  });
                setSelectedRows(updatedRows);
              }
            }}
          />
        </div>
      </Grid>
    </>
  );
}
